import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';
import { initializeScrollHandler, enableScroll, disableScroll } from './scrollHandler.js';
import { getState, setState } from './stateManager.js';
import * as UTIL from './utils.js';

console.log('productthree v1.0.18');

const DEFAULT_CAMERA_POSITION = new THREE.Vector3(-1.75, 0.01, 0.66);
const DEFAULT_CAMERA_LOOKAT = new THREE.Vector3(0, 0, 0);

export let controls;
export let overlayContentElements;
export let threejsLayer;

let envFactor, cameraTargetPosition, cameraTargetPositions, cameraTargetLookAt, cameraTargetLookAts, camera, scene, renderer, camera2, scene2, renderer2;
let pumpVector, targetLookAt, lerpAlpha, animationComplete, animationStarted, raycaster;
let threejsOverlayDIV, threejsModalDIV, threejsOverlayContainer,threejsContainer, headlineTypo3, threejsButtonContainer, threejsHeight, threejsWidth, buttons, buttonsDiv;
let threejsElement, threejsElement2, wrapperElement, contentElement, headerElement, breadElement, errorElement;
let threejsCanvas, wrapperRect, overlayRect;
let textureLoader, iconTexture, spriteMaterial, iconSprite;
let overlayIconElements, threejsRect;
let iconLoad, iconDown, icon360;
let duration, startTime, triggerCameraRotation, rotationStartTime, rotationDuration, radius, target, currentElementIndex;
let rerender = false;
let currentCameraPosition = DEFAULT_CAMERA_POSITION; 
let currentCameraLookAt = DEFAULT_CAMERA_LOOKAT; 
let lastAnimationFrame, lastAnimationFrameSmart, lastAnimationFrame360;
let spline;
let lastFrameTime = 0;
let lastFrameTimeSmart = Date.now();
const animationDuration = 1000;
const FPS_LIMIT = 30;

async function contentLoaded() {
}

async function windowLoaded() {
        await initializeElements();
	await init();
        await initializeRenderers();
	setState('visibleElementIndex', getVisibleElementIndex());
	threejsModalDIV.addEventListener('click', (event) => {
                if (event.target.tagName === 'A' && event.target.hash) {
			setState('animationInProgress',  true);
		        hideIcon();
	                clearModal();
			removeModal();
                        hideIconDown();
			setTimeout(() => {
                                const scrollPosition = window.scrollY;
                                setState('lastScrollPosition', scrollPosition);
				setState('animationInProgress',  false);
				setState('visibleElementIndex', getVisibleElementIndex());
		        	enableScroll();
				disableControls();
				hideIcon();
                        }, 100);
                }
        });
        const anchor = location.hash; 
        if (anchor && anchor != '') {
			const anchorElement = document.querySelector(anchor);
			if (anchorElement) {
				window.scrollTo(0, anchorElement.offsetTop);
				hideIcon360();
				hideIconDown();
				enableScroll();
				disableControls();
				setTimeout(function() {
					initializeScrollHandler(animateSpline, animateSmart, 0, getVisibleElementIndex, controls);
				}, 1000);
			}
	} else {
		window.oldHeight = window.innerHeight;
	       	if(window.innerWidth>=900) {
			animate();
		} else {
			showIconDown();
			enableControls();
			lastAnimationFrameSmart = requestAnimationFrame(animateSmart);
			initializeScrollHandler(animateSpline, animateSmart, 0, getVisibleElementIndex, controls);
		}
	}
	hideIconLoad();
	removeModal();
}
async function initializeElements() {
        threejsElement = getElementOrLogError("canvas-container");
        threejsElement2 = getElementOrLogError("canvas-container2");
        errorElement = getElementOrLogError("threejs-error");
        wrapperElement = getWrapperElement();
        breadElement = document.querySelector('.breadcrumbs-block');
        contentElement = document.querySelector('#main .Default .wrapper .Default');
        headerElement = getElementOrLogError('header');
        threejsLayer = getElementOrLogError('threejsLayer');
        threejsOverlayDIV = getElementOrLogError('threejsOverlay');
        threejsModalDIV = getElementOrLogError('threejsModal');
        threejsOverlayContainer = threejsOverlayDIV.querySelector('.threejsOverlay-container');
        threejsButtonContainer = getElementOrLogError('button-container');
        headlineTypo3 = document.querySelector('.wrapper h1');
	overlayContentElements = document.querySelectorAll('.overlay-content');
	overlayIconElements = threejsOverlayDIV.getElementsByClassName('overlay-icon');
	iconLoad = getElementOrLogError('.icon_load');
	iconDown = getElementOrLogError('.icon_down');
        if(headlineTypo3) {
                updateHeadlineStyle(headlineTypo3);
        }
}

async function init() {
	disableScroll();
	clearModal();
	envFactor = 1.0;
	cameraTargetPosition = DEFAULT_CAMERA_POSITION;
	cameraTargetLookAt = DEFAULT_CAMERA_LOOKAT;
	pumpVector = new THREE.Vector3(0,-0.8,0).multiplyScalar(envFactor);
	targetLookAt = DEFAULT_CAMERA_LOOKAT;
	lerpAlpha = 1;
	animationComplete = true;
	animationStarted = false;
	raycaster = new THREE.Raycaster();
 	textureLoader = new THREE.TextureLoader();
	triggerCameraRotation = false;
	rotationStartTime = null;
	rotationDuration = 15000; 
	radius = 2.5; 
	target = new THREE.Vector3(0, 0, 0);
	cameraTargetPositions = Array.from(overlayContentElements).map((element) => {
	    const positionAttribute = element.getAttribute('data-position');
	    const [x, y, z] = positionAttribute.split(',').map(parseFloat);
	    return new THREE.Vector3(x, y, z).multiplyScalar(envFactor);
	});

	cameraTargetLookAts = Array.from(overlayContentElements).map((element) => {
	    const positionAttribute = element.getAttribute('data-lookAt');
	    const [x, y, z] = positionAttribute.split(',').map(parseFloat);
	    return new THREE.Vector3(x, y, z).multiplyScalar(envFactor);
	});
	if(window.innerWidth<900) {
		currentElementIndex = -1;
		duration = 1500; 
		envFactor = 1.2;
		DEFAULT_CAMERA_POSITION.multiplyScalar(envFactor);
	} else {
		currentElementIndex = 0;
		duration = 500;
	}
}

function animate360() {
	if(controls.enabled) {
		renderer.render(scene, camera);
		renderer2.render(scene2, camera2);
		lastAnimationFrame360 = requestAnimationFrame(() => {
                        animate360();
                });		
	}
	return;
}

export function animateSmart() {
        renderer.render(scene, camera);
        renderer2.render(scene2, camera2);
}

function animate() {
	const now = Date.now();
	const timeSinceLastFrame = now - lastFrameTime;
	if(timeSinceLastFrame >= 1000/FPS_LIMIT) {
		lastFrameTime = now;
	} else {
		lastAnimationFrame = requestAnimationFrame(() => {
			animate();
		});
		return;
	}
	let timeElapsed = Date.now() - startTime;
	if(animationStarted) {
                if(!animationComplete) {
                         if (triggerCameraRotation) {
				if (rotationStartTime === null) {
					rotationStartTime = Date.now();
				}
                                animateCameraAroundObject(target, radius);
                        } else {
                                let lerpAlpha = timeElapsed / duration;
                                if (lerpAlpha < 1) {
					const currentLookAt = currentCameraLookAt.clone().lerp(targetLookAt, lerpAlpha);
					const currentPosition = currentCameraPosition.clone().lerp(cameraTargetPosition, lerpAlpha);
                                        camera.position.copy(currentPosition);
                                        camera2.position.copy(currentPosition);
                       			camera.lookAt(currentLookAt);
                       			camera2.lookAt(currentLookAt);
					camera.updateProjectionMatrix();
					camera2.updateProjectionMatrix();
                                } else {
                                        animationComplete = true;
                                        animationStarted = false;
                                }
                        }
                }
        }
	if (window.scrollY >= 50) {
		disableControls();
		animationStarted = false;
		animationComplete = true;
		deactivateThreejsOverlay();
		threejsLayer.style.display = 'none';
		if(animationStarted || !animationComplete) {
			animationStarted = false;
			cameraTargetPosition = DEFAULT_CAMERA_POSITION; 
			targetLookAt = DEFAULT_CAMERA_LOOKAT;
			camera.position.copy(cameraTargetPosition);
			camera2.position.copy(cameraTargetPosition);
			camera.lookAt(targetLookAt);
			camera2.lookAt(targetLookAt);
			camera.updateProjectionMatrix();
			camera2.updateProjectionMatrix();
			animationComplete = true;
		}
	} else {
		if(controls.enabled && threejsLayer.style.display != 'block') {
			threejsLayer.style.display = 'block';
		}
	}
	const directionVector = new THREE.Vector3();
	camera.getWorldDirection(directionVector);
        renderer.render(scene, camera);
        renderer2.render(scene2, camera2);
	lastAnimationFrame = requestAnimationFrame(animate);
}

export function disableControls() {
	hideIcon360();
	if(controls.enabled !== false) {
	controls.enabled = false;
		controls.update();
	}
}

export function enableControls() {
	showIcon360();
	animate360();
	if(controls.enabled !== true) {
		controls.enabled = true;
		controls.update();
	}
}
export function animateSpline(layerbg = false) {
	const scrollY = window.scrollY;
	if(getState('clear')) { 
		hideIcon();
		clearModal();
		setState('clear', false);	
	}
	if(layerbg) {
		removeModal();
	}
	//disable orbitControls when scrolling down
	if (controls.enabled && scrollY >= 100) {
		disableControls();
	} 
	if (scrollY < 100) {
		if(!controls.enabled) {
			enableControls();
		}
		hideIcon();
		clearModal();
	}
	if (!getState('animationInProgress')) {
		//getVisibleElementIndex();
		setState('visibleElementIndex', getVisibleElementIndex());
		if(getState('visibleElementIndex')<=0 && window.scrollY < 100) {
			camera.position.copy(DEFAULT_CAMERA_POSITION);
			camera.lookAt(DEFAULT_CAMERA_LOOKAT);
		}
		return;
	}
	if (getState('animationInProgress')) { 
		const now = Date.now();
		const timeSinceLastFrameSmart = now - lastFrameTimeSmart;
		//check FrameLimit
		if(timeSinceLastFrameSmart >= 1000/FPS_LIMIT) {
			lastFrameTimeSmart = now;
		} else {
			lastAnimationFrameSmart = requestAnimationFrame(() => {
				animateSpline();
			});
			return;
		}
		//after end of animation pause for x.
		const elapsedTime = now - getState('animationStartTime');
		const pause = 2000;
		if(now - getState('animationEndTime') < pause) {
			lastAnimationFrameSmart = requestAnimationFrame(() => {
	        	        animateSpline();
		        });
			return;
		}
		
		//scroll to position by elaped time
		const progress = Math.min(elapsedTime / animationDuration, 0.999);
		let visibleElementIndex = getState('visibleElementIndex');
		if (visibleElementIndex !== -1) {
			const { relativeScrollPosition, elementHeight, elementStart } = calculateRelativeScrollPosition(overlayContentElements, visibleElementIndex);
			let nsp = UTIL.roundNumber(elementStart + (progress * elementHeight), 0);
			let lastScrollPosition = UTIL.roundNumber(getState('lastScrollPosition'), 0);
			window.scrollTo(0, nsp);
			if(nsp > lastScrollPosition) {
				setState('lastScrollPosition', nsp);
			}  
			const targetIndex = determineTargetIndex(relativeScrollPosition, visibleElementIndex, elementHeight, overlayContentElements);
			const { realScrollPercentage, shadowScrollPercentage } = calculateScrollPercentage(relativeScrollPosition, elementHeight);
			if (targetIndex !== currentElementIndex) {
				let offset = targetIndex > currentElementIndex ? 0 : -2;
				let startPosition = (currentElementIndex + offset >= 0) ? cameraTargetPositions[currentElementIndex + offset] : DEFAULT_CAMERA_POSITION;
				let targetPosition = cameraTargetPositions[targetIndex];
				currentElementIndex = targetIndex;
				spline = createSplineCurve(startPosition, targetPosition);
			}
			if(spline) {	
				doSpline(shadowScrollPercentage, targetIndex);
			}
		} else {
			clearModal();
			if (currentElementIndex !== -1) {
				currentElementIndex = -1;
			}
			camera.position.copy(DEFAULT_CAMERA_POSITION);
			camera.lookAt(DEFAULT_CAMERA_LOOKAT);
			threejsElement2.style.width = threejsWidth+'px';
			threejsElement2.style.left = -wrapperRect.left + 'px';
			hideIcon();
		}
		//Animation end
		if (elapsedTime >= animationDuration) {
			setState('lastElementScrolled', getState('visibleElementIndex'));
			setState('animationInProgress', false);
			setState('animationStartTime',  null); 
			setState('animationEndTime',  Date.now());
			document.body.classList.remove('no-scroll');
			threejsLayer.classList.add('layerbg');
			showIcon(visibleElementIndex);
			if(threejsModalDIV.innerHTML !== overlayContentElements[visibleElementIndex].innerHTML) {
				threejsModalDIV.innerHTML = overlayContentElements[visibleElementIndex].innerHTML;
//				threejsModalDIV.style.pointerEvents = 'all';
			}
			setState('visibleElementIndex', getVisibleElementIndex());
			if (iconDown) {
				iconDown.style.display = 'block';
			}
        		renderer.render(scene, camera);
		        renderer2.render(scene2, camera2);
			return;
		}
        	renderer.render(scene, camera);
	        renderer2.render(scene2, camera2);
	}
	lastAnimationFrameSmart = requestAnimationFrame(() => {
		animateSpline();
	});
	return;
}

export function getVisibleElementIndex() {
	let scrollY = window.scrollY;
	let index = -1;
	for (let i = 0; i < overlayContentElements.length; i++) {
		if (scrollY >= (overlayContentElements[i].offsetTop) && scrollY <= (overlayContentElements[i].offsetTop + overlayContentElements[i].offsetHeight)) {
			index = i;
		}
	}
	if(index==-1) {
		removeModal();
		clearModal();
		if(scrollY > window.innerHeight) {
			index = overlayContentElements.length;
		}
	}
	return index;
}

function calculateRelativeScrollPosition(overlayContentElements, visibleElementIndex) {
	if(rerender || !overlayContentElements[visibleElementIndex].elementStart) {
        overlayContentElements[visibleElementIndex].elementStart = overlayContentElements[visibleElementIndex].offsetTop;
        overlayContentElements[visibleElementIndex].elementHeight = overlayContentElements[visibleElementIndex].offsetHeight;
	rerender = false;
    }
    const elementStart = overlayContentElements[visibleElementIndex].elementStart;
    const elementHeight = overlayContentElements[visibleElementIndex].elementHeight;
    const relativeScrollPosition = window.scrollY - elementStart; 
    return {
        relativeScrollPosition,
        elementHeight,
        elementStart
    };
}

function determineTargetIndex(relativeScrollPosition, visibleElementIndex, elementHeight, overlayContentElements) {
	let targetIndex = visibleElementIndex;
	if (relativeScrollPosition > elementHeight && visibleElementIndex < overlayContentElements.length - 1) {
		targetIndex++;
	} else if (relativeScrollPosition < -elementHeight && visibleElementIndex > 0) {
		targetIndex--;
	}
	return targetIndex;
}

function calculateScrollPercentage(relativeScrollPosition, elementHeight) {
    let realScrollPercentage = 0 + (relativeScrollPosition / elementHeight);
    realScrollPercentage = Math.max(0, Math.min(realScrollPercentage, 1));
    let shadowScrollPercentage;
    if(realScrollPercentage < 0) { shadowScrollPercentage = 0; }
    if(realScrollPercentage >= 0.0 && realScrollPercentage <= 0.5) { shadowScrollPercentage = (realScrollPercentage-0) / (0.5 - 0); }
    if(realScrollPercentage > 0.5) { shadowScrollPercentage = 1; }
    return { realScrollPercentage, shadowScrollPercentage };
}

function initializeOverlayContent(content, icon, uid, iconAtVector, i) {
    content.style.display = 'none';
    content.style.left = `${overlayRect.left + 16}px`;
    icon.style.display = 'none';
    icon.classList.add('fade-transition');
    if (content.getAttribute('data-uid') === uid) {
	targetLookAt = (i >= 0) ? cameraTargetLookAts[i].clone() : DEFAULT_CAMERA_LOOKAT;
        content.style.display = 'flex';
        content.classList.remove('d-md-none');
        content.addEventListener('click', deactivateThreejsOverlay);
        handleHeadline(content);
        handleIcon(icon, iconAtVector, true);
    }
}

async function initOverlays() {
	overlayIconElements = threejsOverlayDIV.getElementsByClassName('overlay-icon');
	overlayContentElements = threejsOverlayDIV.getElementsByClassName('overlay-content');
	let imgElement;
	let headlineContainer = document.createElement('div');
	headlineContainer.style.position = 'absolute';
	headlineContainer.style.left = '0';
	headlineContainer.style.top = '0';
	headlineContainer.style.color = '#ffffff';
	headlineContainer.style.textDecoration = 'none';
	headlineContainer.classList.add('headline-container');
	document.body.appendChild(headlineContainer);
	for (let i = 0; i < overlayContentElements.length; i++) {
		overlayContentElements[i].style.left = (overlayRect.left+16)+'px';
		overlayContentElements[i].style.height = (overlayRect.height )+'px';
		overlayContentElements[i].style.display = 'flex';
		overlayIconElements[i].style.display = 'none';
		let headlineOverlay = document.createElement('div');
		headlineOverlay.classList.add('headline-overlay');
	        let headline = overlayContentElements[i].querySelector('h3'); 
	        if (headline) {
			let rect = headline.getBoundingClientRect();
			let clonedHeadline = headline.cloneNode(true);		
			headlineOverlay.style.position = 'fixed';
			headlineOverlay.style.zIndex = '4000';
			headlineContainer.appendChild(headlineOverlay);
			headlineOverlay.style.height = `0`;
			headlineOverlay.style.left = `${rect.left}px`;
			headlineOverlay.style.top = `${rect.top}px`;
			headlineOverlay.style.width = `${rect.width}px`;
	        }
		let iconElement = overlayIconElements[i];
		if (iconElement) {
			imgElement = iconElement.querySelector('img');
			if(imgElement) {
				const iconAtString = overlayContentElements[i].getAttribute('data-iconAt');
				let iconAtVector = new THREE.Vector3(...iconAtString.split(',').map(Number));
				imgElement.style.display = 'none';
				imgElement.src = '/typo3conf/ext/productthree/Resources/Public/Images/icon.png';
				iconTexture = textureLoader.load(imgElement.src);
				spriteMaterial  = new THREE.SpriteMaterial({ map: iconTexture, color: 0xffffff });
				iconSprite = new THREE.Sprite(spriteMaterial);
				iconSprite.scale.set(0.3, 0.3, 0.3);
				iconSprite.material.opacity = 1;
				setTimeout(() => {
					const gltfPos = new THREE.Vector3();
					window.gltf.getWorldPosition(gltfPos);
					const iconAtString = overlayContentElements[i].getAttribute('data-iconAt');
					let iconAtVector = new THREE.Vector3(
						...iconAtString.split(',').map(Number)
					);
					const iconPos = gltfPos.clone().add(iconAtVector);
					iconSprite.position.copy(iconPos);
					fadeInOpacity(1000, iconSprite);
				}, 100);
			} else {
				overlayContentElements[i].hideImg = true;
			}
		}
	}
}

function handleIcon(iconElement, iconAtVector, addToScene = false, scale = 0.3, opacity = 1) {
    const imgElement = iconElement.querySelector('img');
    if (!imgElement) return;
    imgElement.style.display = 'none';
    fetch(imgElement.src, {mode: 'cors'})
        .then(response => response.text())
        .then(data => {
            const parser = new DOMParser();
            const svgDoc = parser.parseFromString(data, "image/svg+xml");
            const svg = svgDoc.documentElement;
            svg.setAttribute("width", "612");
            svg.setAttribute("height", "612");
            const serializedSVG = new XMLSerializer().serializeToString(svg);
            const src = "data:image/svg+xml;base64," + btoa(serializedSVG);
            textureLoader.load(src, (texture) => {
                const spriteMaterial = new THREE.SpriteMaterial({ map: texture, transparent: true, color: 0xf47106  });
                const iconSprite = new THREE.Sprite(spriteMaterial);
                iconSprite.scale.set(scale, scale, scale);
                iconSprite.material.opacity = opacity;
                setTimeout(() => {
                    const gltfPos = new THREE.Vector3();
                    window.gltf.getWorldPosition(gltfPos);
                    const iconPos = gltfPos.clone().add(iconAtVector);
                    iconSprite.position.copy(iconPos);
                    if(addToScene) scene2.add(iconSprite);
                    fadeInOpacity(1000, iconSprite);
                }, 100);
            });
        });
}

function animateCameraAroundObject(target, radius) {
    let currentTime = Date.now();
    let elapsed = currentTime - rotationStartTime;
    if (elapsed < rotationDuration) {
        let angle = Math.PI * 2 * ((elapsed / (rotationDuration/4))-0.5); 
        camera.position.x = -target.x + radius * Math.cos(angle);
        camera.position.z = target.z + radius * Math.sin(angle);
        camera.lookAt(target);

        if(triggerCameraRotation) requestAnimationFrame(() => animateCameraAroundObject(target, radius)); 
    } else {
        triggerCameraRotation = false;
        rotationStartTime = null;
	deactiveThrejsOverlay();
    }
}

function doSpline(pc, targetIndex) {
	const splinePosition = pc;
	let newPosition = spline.getPoint(splinePosition);
	const targetLookAt = cameraTargetLookAts[targetIndex];
	const currentLookAt = currentCameraLookAt.clone().lerp(targetLookAt, pc);
	camera.position.copy(newPosition);
	camera.lookAt(currentLookAt);
	camera.updateProjectionMatrix();
}
export function removeModal() {
	threejsLayer.classList.remove('layerbg');
}

export function clearModal() {
	if(threejsModalDIV.innerHTML !== '') {
		threejsModalDIV.innerHTML = '';
	}
//	threejsModalDIV.style.pointerEvents = 'none';
}

function calculateSplinePosition(relativeScrollPosition, elementHeight) {
	return relativeScrollPosition / elementHeight;
}

function createSplineCurve(startPosition, targetPosition) {
    var origin = new THREE.Vector3(0, 0, 0);
    var startDirection = startPosition.clone().sub(origin).normalize();
    var targetDirection = targetPosition.clone().sub(origin).normalize();
    // Berechnen des Winkels zwischen den Richtungen
    var angle = Math.acos(startDirection.dot(targetDirection));
    // Bestimmen des height-Parameters basierend auf dem Winkel
    var height;
    if (Math.abs(angle - Math.PI) < Math.PI / 6) { // Winkel nahe 180 Grad
        height = 0.75; // Maximale Höhe, wenn gegenüberliegend
    } else {
        height = 0.15 + 0.5 * Math.abs(angle) / Math.PI; // Reduzieren von height basierend auf dem Winkel
    }
    // Berechnen des Mittelpunkts
    var midpoint = new THREE.Vector3().addVectors(startPosition, targetPosition).multiplyScalar(0.5);
    midpoint.z += height;
    midpoint.y += height;
    midpoint.x += height;

    return new THREE.CatmullRomCurve3([startPosition, midpoint, targetPosition]);
}

function getElementOrLogError(elementId) {
	const element = document.getElementById(elementId) || document.querySelector(elementId);
	if (!element) {
		console.error(`productthree: no ${elementId}`);
	}
	return element || null;
}

function getWrapperElement() {
        let wrapper = document.querySelector('#wrapper');
        if (!wrapper) {
                console.error('productthree: no wrapper: use body');
                wrapper = document.body;
        }
        return wrapper;
}

function updateHeadlineStyle(element) {
        element.style.zIndex = "1018";
        element.style.position = "relative";
}

async function initializeRenderers() {
        const { clientWidth, clientHeight } = wrapperElement;
        wrapperRect = contentElement.getBoundingClientRect();
        threejsRect = threejsElement.getBoundingClientRect();
        threejsHeight = window.innerHeight - headerElement.clientHeight;
        threejsWidth = threejsRect.width;
        overlayRect = threejsOverlayDIV.getBoundingClientRect();
        handleResponsiveDesign(window.innerWidth, window.innerHeight);
        setupRenderers(threejsWidth, threejsHeight);
        await setupScenes();
}

function handleResponsiveDesign(windowWidth, windowHeight) {
        if(windowWidth<900) {
                threejsOverlayDIV.style.marginBottom = (window.innerHeight - threejsRect.top ) + 'px';
                threejsElement2.style.width = threejsWidth+'px';
                threejsElement2.style.left = -wrapperRect.left + 'px';
        } else {
                threejsOverlayDIV.style.height = threejsHeight+'px';
                threejsOverlayDIV.style.display = 'none';
                threejsOverlayDIV.style.visibility = 'visible';
                threejsOverlayDIV.classList.add('fade-transition');
                threejsElement2.classList.add('fade-transition');
                breadElement.classList.add('fade-transition');
                contentElement.style.height = (threejsHeight-102) + 'px';
                threejsButtonContainer.classList.add('fade-transition');
                if(headlineTypo3) headlineTypo3.classList.add('fade-transition');
        }
        threejsElement2.style.display = 'none';
        threejsElement2.style.height = threejsHeight+'px';
}

function setupRenderers(width, height) {
        renderer = createRenderer(width, height);
        renderer2 = createRenderer(width, height);
        threejsElement.appendChild(renderer.domElement);
        threejsElement2.appendChild(renderer2.domElement);
}

function createRenderer(width, height) {
        const pixelRatio = window.devicePixelRatio;
        const renderer = new THREE.WebGLRenderer({ antialias: true, logarithmicDepthBuffer: true, alpha: true });
        renderer.setClearColor(0x000000, 0);
        renderer.setPixelRatio(pixelRatio);
        renderer.setSize(width, height);
        renderer.shadowMap.enabled = true;
        renderer.shadowMap.type = THREE.PCFSoftShadowMap;
        return renderer;
}

async function setupScenes() {
	scene = new THREE.Scene();
	scene2 = new THREE.Scene();
	camera = new THREE.PerspectiveCamera(64, threejsWidth / threejsHeight, 0.1, 1000);
	camera.position.copy(DEFAULT_CAMERA_POSITION);
	camera2 = camera;
	await loadModels();
	controls = new OrbitControls(camera, renderer.domElement);
	UTIL.configureControls(controls);
	setupOverlaysAndButtons();
	addLight();
	return true;
}

async function loadModels() {
    const loader = new GLTFLoader();
    try {
        const gltf = await new Promise((resolve, reject) => {
            loader.load(threejsElement.dataset.glbPath, resolve, undefined, reject);
        });
        gltf.scene.traverse(UTIL.setSpecificShadows);
	gltf.scene.rotation.x = -Math.PI / 2; 
        gltf.scene.position.copy(pumpVector);
        window.gltf = gltf.scene;
        scene.add(gltf.scene);
        if (window.innerWidth < 900) {
            await initOverlays();
        }
    } catch (error) {
        console.error("Ein Fehler ist beim Laden des GLB-Modells aufgetreten:", error);
        errorElement.innerHTML = "Leider konnte das 3D-Modell nicht geladen werden.";
    }
}

function resizeHandler(event) {
	rerender = true;
        threejsRect = threejsElement.getBoundingClientRect();
        threejsHeight = window.innerHeight - headerElement.clientHeight;
        threejsWidth = threejsRect.width;
        if(window.innerWidth<900) {
                threejsHeight = window.innerHeight - threejsRect.top;
                threejsOverlayDIV.style.position = 'relative';
                threejsOverlayDIV.style.display = 'block';
                threejsOverlayDIV.classList.remove('d-none');
                threejsOverlayDIV.style.top = (window.innerHeight - threejsRect.top ) + 'px';
                threejsOverlayDIV.style.marginBottom = (window.innerHeight - threejsRect.top ) + 'px';
                threejsLayer.style.height = (window.innerHeight - threejsRect.top ) + 'px';
                threejsCanvas.style.touchAction = 'pan-y';
                threejsContainer.style.height = threejsHeight+'px';
		window.scrollTo(0, window.scrollY + (window.innerHeight-window.oldHeight));
		window.oldHeight = window.innerHeight;
        	camera.aspect = threejsWidth / threejsHeight;
	        camera.updateProjectionMatrix();
	        renderer.setSize(threejsWidth, threejsHeight);
	        renderer2.setSize(threejsWidth, threejsHeight);
		animateSmart();
        } else {
                threejsOverlayDIV.style.top =  threejsRect.top + 'px';
                threejsOverlayDIV.style.position = 'fixed';
                threejsOverlayDIV.style.height = threejsHeight+'px';
	        camera.aspect = threejsWidth / threejsHeight;
	        camera.updateProjectionMatrix();
	        renderer.setSize(threejsWidth, threejsHeight);
	        renderer2.setSize(threejsWidth, threejsHeight);
        }
}

document.addEventListener('DOMContentLoaded', contentLoaded);
window.addEventListener('resize', resizeHandler);
window.addEventListener('load', windowLoaded);


function setupOverlaysAndButtons() {
        let divs = document.querySelectorAll('#main>div');
        let divs2 = document.querySelectorAll('.bg-secondary');
        let section = document.querySelectorAll('.newsletter-section');
        let footer = document.querySelectorAll('#footer');
	threejsContainer = document.getElementById('threejs-container');
	const headerTemp = document.getElementById('header');
	threejsContainer.style.height = (window.innerHeight-headerTemp.clientHeight) + 'px';
	threejsLayer.style.height = (window.innerHeight-headerTemp.clientHeight) + 'px';
        divs = [...divs, ...divs2];
        divs = [...divs, ...section];
        divs = [...divs, ...footer];
        divs.forEach(function(div) {
                if(div.style.position=='' || div.style.position == 'static') div.style.position = 'relative';
                div.classList.remove('mt-5');
        });
        buttons = document.querySelectorAll('#button-container button');
        buttons.forEach(function(button) {
                button.addEventListener('click', function() {
                        var uid = this.getAttribute('data-uid');
                        var position = this.getAttribute('data-position');
                        var iconAt = this.getAttribute('data-iconAt');
                        var lookAt = this.getAttribute('data-lookAt');
                        activateThreejsOverlay(uid, position, iconAt, lookAt);
                });
        });
        buttonsDiv = document.querySelector('#button-container .buttons');
        let buttonOpener = document.querySelector('#button-container .nav3d-opener');
        buttonOpener.addEventListener('click', function(event) {
                event.preventDefault();
                if (buttonsDiv.classList.contains("d-none")) {
                        buttonOpener.classList.add("d-none");
                        buttonOpener.classList.remove("d-block");
                        buttonsDiv.classList.remove("d-none");
                } else {
                        buttonsDiv.classList.add("d-none");
                        buttonOpener.classList.add("d-block");
                        buttonOpener.classList.remove("d-none");
                }
        });
        threejsElement2.addEventListener("click", deactivateThreejsOverlay);
        threejsCanvas = document.querySelector("#canvas-container canvas");
        threejsCanvas.style.touchAction = 'pan-y';
        threejsContainer.classList.remove('unseen');
        threejsElement.classList.remove('unseen');
        threejsElement2.classList.remove('unseen');
}

function addLight() {
        const pointLightFront = UTIL.addLight(scene, 'PointLight', { lightName: 'FrontLight', position: {x:-13, y:0.5, z:-24}, color: '0xefefef', intensity: 25, distance: 45, decay: 0.4, receiveShadow: true, castShadow: false });
        const pointLightBack = UTIL.addLight(scene, 'PointLight', { lightName: 'BackLight', position: {x:3,y:1,z:0}, color: '0xFFFFFF', intensity: 8, distance: 30, decay: 2, castShadow: false });
        const  pointLightLeft = UTIL.addLight(scene, 'PointLight', { lightName: 'LeftLight', position: {x:0,y:2,z:-3}, color: '0xFFFFFF', intensity: 8, distance: 51, decay: 2,castShadow: true });
        const  pointLightRight = UTIL.addLight(scene, 'PointLight', { lightName: 'RightLight', position: {x:0,y:2,z:3}, color: '0xFFFFFF', intensity: 8, distance: 82, decay: 2,receiveShadow: true, castShadow: false });
        const  pointLightTop = UTIL.addLight(scene, 'PointLight', { lightName: 'TopLight', position: {x:0,y:4,z:0}, color: '0xFFFFFF', intensity: 34, distance: 30, decay: 2,castShadow: false });
}

function showButtons() {
	threejsButtonContainer.style.opacity = '1';
	threejsButtonContainer.style.display = 'block';
	threejsButtonContainer.classList.remove("d-none");
	buttonsDiv.classList.remove("d-none");
}

function hideButtons() {
	threejsButtonContainer.style.opacity = '0'; 
	threejsButtonContainer.style.display = 'none'; 
	threejsButtonContainer.classList.remove("d-md-block");
	buttonsDiv.classList.remove("d-md-block");
}

function handleHeadline(content) {
	const headline = content.querySelector('.headline');
	if (headline) {
		headlineOverlay.appendChild(headline);
		headlineOverlay.style.position = 'fixed';
		headlineOverlay.style.zIndex = '4000';
		headlineOverlay.style.top = '0'; 
		headlineOverlay.style.left = '0'
	}
}

function fadeInOpacity(duration=1000, iconSprite) {
	const startTime = performance.now();
	function fade() {
	        const elapsed = performance.now() - startTime;
	        const fraction = Math.min(elapsed / duration, 1);
	        iconSprite.material.opacity = fraction;
        	if (fraction < 1) {
			requestAnimationFrame(fade);
		}
	}
	fade();
}

function showIcon(index) {
	if(overlayContentElements[index].hideImg) {
		return;
	}	
	threejsElement2.classList.remove('d-none');
	threejsElement2.style.display = 'block';
	const gltfPos = new THREE.Vector3();
	window.gltf.getWorldPosition(gltfPos);
	const iconAtString = overlayContentElements[index].getAttribute('data-iconAt');
	let iconAtVector = new THREE.Vector3(
		...iconAtString.split(',').map(Number)
	);
	const iconPos = gltfPos.clone().add(iconAtVector);
	iconSprite.position.copy(iconPos);
        iconSprite.material.opacity = 1;
	if (iconSprite.parent === null) {
    		scene2.add(iconSprite);
	} else {
		iconSprite.visible = true;
	}
	iconSprite.visible = true;
	//scene2.add(iconSprite);
	if(window.innerWidth>=900) controls.enabled = false;
}

export function hideIcon() {
	if(window.innerWidth>=900) controls.enabled = true;
//	scene2.remove(iconSprite);
	if(iconSprite) { 
		iconSprite.visible = false;
		lastAnimationFrameSmart = requestAnimationFrame(animateSmart);
	}
}

export function hideIcon360() {
	const icon360Element = document.querySelector('.icon');
	if (icon360Element) {
		icon360Element.style.display = 'none';
	}
} 

export function showIcon360() {
	const icon360Element = document.querySelector('.icon');
	if (icon360Element) {
		icon360Element.style.display = 'block';
	}
}

export function hideIconDown() {
	if (iconDown) {
		iconDown.style.display = 'none';
	}
}

export function showIconDown() {
	if (iconDown) {
		iconDown.style.display = 'block';
	}
}

export function hideIconLoad() {
	if (iconLoad) {
		iconLoad.style.display = 'none';
	}
} 

export function showIconLoad() {
	if (iconLoad) {
		iconLoad.style.display = 'block';
	}
} 

function deactivateThreejsOverlay() {
	if(window.innerWidth>=900) {
		if(triggerCameraRotation) {
			triggerCameraRotation = false;
		} else if(animationStarted||!animationComplete) return; 
		cameraTargetPosition = DEFAULT_CAMERA_POSITION; 
		targetLookAt = DEFAULT_CAMERA_LOOKAT;
	 	lerpAlpha = 0;
		animationStarted = true;
		animationComplete = false;
		startTime = Date.now();
		while (scene2.children.length > 0) { 
			scene2.remove(scene2.children[0]); 
		}
		showButtons();
		threejsLayer.style.display = 'block';
		threejsOverlayDIV.style.opacity = '0';
		threejsElement2.style.opacity = '0'; 
		if(headlineTypo3) headlineTypo3.style.opacity = '1'; 
		breadElement.style.opacity = '1'; 
		threejsElement2.style.display = 'none'; 
		threejsOverlayDIV.classList.add('d-none'); 
		enableControls();
	}
}

function activateThreejsOverlay(uid, positionString, iconAtString, lookAtString) {
	if(window.innerWidth>=900) {
		if(animationStarted||!animationComplete) return;
		if(window.scrollY>0) { window.scrollTo(0, 0); } 	
		threejsLayer.style.display = 'none';
		animationStarted = true;
		animationComplete = false;
		startTime = Date.now();
		disableControls();
		let positionVector = new THREE.Vector3(
			...positionString.split(',').map(Number)
		).multiplyScalar(envFactor);
		let iconAtVector = new THREE.Vector3(
			...iconAtString.split(',').map(Number)
		).multiplyScalar(envFactor);
		let lookAtVector = new THREE.Vector3(
			...lookAtString.split(',').map(Number)
		).multiplyScalar(envFactor);
		if(uid != 6) {
			cameraTargetPosition = positionVector;
			camera.lookAt(lookAtVector);
			camera.updateMatrixWorld();
		} else {
			if(triggerCameraRotation) {
				triggerCameraRotation=false;
				deactivateThreejsOverlay();
			} else {
				triggerCameraRotation = true;
			}
		}
		lerpAlpha = 0;
		threejsOverlayDIV.style.display = 'flex';
		threejsElement2.classList.remove('d-md-none');
		threejsElement2.classList.remove('d-block');
		threejsElement2.classList.remove('d-none'); 
		threejsElement2.style.display = 'flex';
		threejsOverlayDIV.classList.remove('d-none'); 
		threejsOverlayDIV.classList.remove('d-block'); 
		threejsOverlayDIV.classList.remove('d-md-none'); 
		threejsOverlayContainer.classList.remove('d-md-none'); 
		for (let i = 0; i < overlayContentElements.length; i++) {
			const content = overlayContentElements[i];
			const icon = overlayIconElements[i];
			initializeOverlayContent(content, icon, uid, iconAtVector, i);
		};
		breadElement.style.opacity = '0'; 
		if(headlineTypo3) headlineTypo3.style.opacity = '0';
		hideButtons(); 
		threejsOverlayDIV.style.opacity = '1'; 
		threejsElement2.style.opacity = '1'; 
	}
}

